export const PRESENT = {
    code: 'present',
    text: 'Present'
}
export const PERMANENT = {
    code: 'permanent',
    text: 'Permanent'
}